const noop = args => args;

export default {
  methods: {
    /**
     *
     *  获取分页数据的统一方法，可传入 transformList 对返回数据统一处理
     * @param {*} url
     * @param {*} [transformList=noop]
     * @returns
     */
    getPagingData(url, emptyValue,moduleName) {
      this.emptyText = this.$LS.loading;
      this.tableData = [];
      const params = {
        pageMessage: {
          pageSize: this.pageSize || 10,
          pageNo: this.currentPage,
        },
        data: {
          ...this.searchParam,
        },
      };
      return this.$_post(url, params).then((res) => {
        if (emptyValue !== undefined) {
          this.emptyText = this.$LS.empty;
        } else {
          this.emptyText = this.$LS.emptySearch;
        }
        // list 可能为 null
        // sumCount 可能为 null
        this.tableData = res.data !== undefined ? res.data.list : [];
        this.sumCount = res.sumCount || 0;
        // 字典项
        if (moduleName !== undefined && moduleName === 'dict') {
          this.defSortVal = res.data !== undefined ? res.data.defSortVal : 0;
        }
        // 功能维护
        if (res.data !== undefined && res.data.treeList !== undefined) {
          this.menuData = res.data.treeList;
        }
      });
    },
  },
};
